import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import "./BrandBlue.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <About />
      <section id="contact" className="contact section">
        <div className="container">
          <div className="contact-layout">
            <div className="contact-intro">
              <p className="contact-kicker">Parlons de votre projet</p>
              <h3 className="section-title">Faisons avancer vos idées.</h3>
              <p className="contact-description">
                Décrivez-nous votre besoin en systèmes ou logiciels informatiques.
                HIA Technologie Group vous recontactera pour échanger sur votre projet.
              </p>
              <div className="contact-details">
                <a className="contact-detail" href="tel:+33769817130">
                  <span className="contact-icon" aria-hidden="true">☎</span>
                  <span className="contact-detail-copy">
                    <span className="contact-detail-label">Téléphone</span>
                    <span className="contact-detail-value">+33 7 69 81 71 30</span>
                  </span>
                  <span className="contact-arrow" aria-hidden="true">↗</span>
                </a>
                <a
                  className="contact-detail"
                  href="https://maps.google.com/?q=59+rue+de+Ponthieu,+75008+Paris"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="contact-icon" aria-hidden="true">⌖</span>
                  <span className="contact-detail-copy">
                    <span className="contact-detail-label">Adresse</span>
                    <span className="contact-detail-value">59 rue de Ponthieu<br />75008 Paris</span>
                  </span>
                  <span className="contact-arrow" aria-hidden="true">↗</span>
                </a>
              </div>
              <p className="contact-note">Réponse par téléphone ou par e-mail après votre demande.</p>
            </div>
            <ContactForm />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default App;
